<template>
  <div class="stripe-method">
    <form @submit="onSubmit">
      <p class="price">{{product.regular_price}} GBP</p>

      <Coupon v-model="coupon" :price="product.regular_price"/>
      <PaymentMethod @input="onPM"/>

      <p class="error" v-if="error && isPaymentError">
        <template v-if="error.key === 'initial-payment-failed'">
          {{$ml.get('The card was declined')}}
        </template>
        <template v-else-if="error.key === '3d-secure-fail'">
          {{$ml.get('The payment was not finished')}}
        </template>
      </p>

      <p class="error" v-else-if="error && error.response && error.response.data && error.response.data.err && error.response.data.err.msg">
        {{ error.response.data.err.msg }}
      </p>

      <app-btn :loading="loading" type="submit">{{$ml.get('continue')}}</app-btn>
    </form>
  </div>
</template>

<script>
import CardInput from '@/components/common/CardInput';
import { PaymentError } from './payment.error';
// import Coupon from '@/components/common/Coupon';
import PaymentMethod from '@/components/common/PaymentMethod';
import {MarketAPI} from "@/api";
import Coupon from "@/components/common/Coupon";

export default {
  props: {
    product: Object
  },
  data() {
    return {
      loading: false,
      error: false,
      pm: null,
      orderId: null,
      coupon: '',
    }
  },
  components: {
    CardInput,
    PaymentMethod,
    Coupon
  },
  methods: {

    onPM(pm) {
      this.pm = pm;
    },

    onSubmit(e) {
      e.preventDefault();
      this.loading = true;
      this.getProduct()
          .catch(err => {
            console.error(err);
            this.error = err;
          })
          .finally(() => {
            this.loading = false;
          });
    },

    async getProduct() {

      try {
        await this.buyProduct();
        await this.$store.dispatch('market/loadAll');
        this.$emit('success');
      } catch (e) {
        throw new PaymentError('Payment error');
      }
    },

    async buyProduct() {

      const pm = await this.$env.stripe.createPaymentMethod(this.pm)
          .then(res => res.paymentMethod);

      if (!pm) {
        throw new PaymentError('Payment error');
      }


      const res = await MarketAPI
          .buyProduct(pm.id, this.product.id, this.coupon)

      if (typeof res.buyed !== 'undefined') {
        return true;
      }

      this.orderId = res.order_id;

      const pi = res.pi;

      console.log('pre pi');
      if(pi.status !== 'succeeded') {
        if(pi.status === 'requires_action') {
          const result = await this.$env.stripe.confirmCardPayment(pi.client_secret);
          if(result.error) {
            throw new PaymentError('3d-secure-fail');
          }
        } else {
          throw new PaymentError('initial-payment-failed');
        }
      }

      console.log('pre confirm');
      await this.confirmTransition();
    },

    async confirmTransition() {
      console.log('confirmation');
      const confirmation = await MarketAPI.confirmTransaction(this.orderId)
          .then(res => res.data);
    }
  },
  computed: {
    isPaymentError() {
      return (this.error instanceof PaymentError);
    }
  }
}
</script>

<style lang="scss" scoped>

.stripe-method {
  form {
    > * {
      margin-top: 25px;
    }
    p.price {
      margin-top: 16px;
      font-size: 22px;
      font-weight: bold;
    }
    .switcher {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      > button {
        flex-basis: 49%;
      }
    }
  }

  .error {
    color: red;
  }
}

</style>
